import script from "./bomlist.vue?vue&type=script&setup=true&lang=js"
export * from "./bomlist.vue?vue&type=script&setup=true&lang=js"

import "./bomlist.vue?vue&type=style&index=0&id=f4bd47d2&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4bd47d2"]])

export default __exports__